import { OverflowTooltip } from '@/components/common/overflow-tooltip';

import styles from './discount-entity-card.module.scss';

export type DiscountEntityCardProps = {
  imageUrl: string | null;
  name: string;
  subtitle: string;
};

/** A single device/bundle tile in the relationship-tab grid (ticket 06). Presentational —
 *  thumb (empty when `imageUrl` is null) + name + subtitle. */
export function DiscountEntityCard({ imageUrl, name, subtitle }: DiscountEntityCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.thumb} aria-hidden={imageUrl ? undefined : true}>
        {imageUrl ? <img className={styles.thumbImg} src={imageUrl} alt={name} /> : null}
      </div>
      <div className={styles.text}>
        {/* A long name or subtitle ellipsises inside the tile; the full value is one hover away. */}
        <OverflowTooltip title={name}>
          <span className={styles.name}>{name}</span>
        </OverflowTooltip>
        <OverflowTooltip title={subtitle}>
          <span className={styles.subtitle}>{subtitle}</span>
        </OverflowTooltip>
      </div>
    </div>
  );
}
